// extracted by mini-css-extract-plugin
export default {"storeIssueItem":"StoreIssueItem_storeIssueItem__zmnnY","message":"StoreIssueItem_message__PVJ2m","issuePrice":"StoreIssueItem_issuePrice__RbI3O"};